import { useEffect, useState } from 'react';
import { Stack, Typography, List, ListItem } from '@mui/material';
import {
  CustomerAddress,
  CustomerAddressInfo,
  CustomerInfo,
  UpdateAddressesRequest,
} from 'orderme-api-integration-client';
import { AddressCard, CancelIconStyled, IconButtonStyled, SadIcon } from './addressBookStyles';
import { RootState } from '../../redux/store';
import { assignCustomerDetails } from '../../helpers/customerHelper';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../redux/hooks';
import { CustomerClient } from '../../helpers/client';
import { Popup } from '../popup/popup';
import { AccountConfirmButton } from '../auth/accountSettings/accountSettingsStyles';

export function MyAddresses() {
  const customerClient: CustomerClient = new CustomerClient();
  const userInfo: CustomerInfo = useAppSelector((state: RootState) => state.customerState.customerInfo);
  const [clientAddresses, setClientAddresses] = useState<CustomerAddressInfo[]>();
  const [addressToDeleteIndex, setAddressToDeleteIndex] = useState<number | null>(null);
  const { t } = useTranslation();

  useEffect(() => {
    if (Object.keys(userInfo).length === 0) {
      assignCustomerDetails();
    } else {
      let addresses = userInfo?.addresses || [];
      setClientAddresses(addresses);
    }
  }, [userInfo]);

  const removeAddress = (index: number) => {
    if (!clientAddresses?.length) {
      return;
    }

    const customerAddresses: CustomerAddress[] = clientAddresses.map((i) => i.address);
    customerAddresses.splice(index, 1);

    updateAddresses(customerAddresses);
  };

  const closeDeleteConfirmation = () => {
    setAddressToDeleteIndex(null);
  };

  const confirmDeleteAddress = () => {
    if (addressToDeleteIndex === null) {
      return;
    }

    removeAddress(addressToDeleteIndex);
    closeDeleteConfirmation();
  };

  const updateAddresses = (customerAddresses: CustomerAddress[]) => {
    var updateRequest = {
      addresses: customerAddresses,
    } as UpdateAddressesRequest;

    customerClient
      .changeAddresses(userInfo.id, updateRequest)
      .then(() => {
        assignCustomerDetails();
      })
      .catch();
  };

  return (
    <>
      {clientAddresses?.length > 0 ? (
        <List>
          {clientAddresses.map((item, index) => (
            <ListItem key={index} disableGutters={true} sx={{ px: '20px', justifyContent: 'center' }}>
              <AddressCard
                sx={{
                  backgroundColor: 'none',
                  color: 'black',
                }}
              >
                {item.address.canDelete && (
                  <IconButtonStyled onClick={() => setAddressToDeleteIndex(index)}>
                    <CancelIconStyled />
                  </IconButtonStyled>
                )}
                <Typography sx={{ padding: '10px 10px 10px 20px' }}>
                  {item.address.address} {item.address.apartmentNumber}
                </Typography>
              </AddressCard>
            </ListItem>
          ))}
        </List>
      ) : (
        <Stack direction="column" alignItems="center" sx={{ mt: '20px' }}>
          <Typography sx={{ fontSize: '20px', color: 'gray' }}>{t('address:missingAddress')}</Typography>
          <SadIcon />
        </Stack>
      )}

      <Popup
        open={addressToDeleteIndex !== null}
        onClose={closeDeleteConfirmation}
        dialogTitle={t('address:deleteAddressConfirmation')}
        dialogActions={
          <Stack direction="row" justifyContent="space-evenly" alignItems="center" sx={{ width: '100%' }}>
            <AccountConfirmButton onClick={closeDeleteConfirmation} variant="contained">
              {t('account:confirmationNo')}
            </AccountConfirmButton>
            <AccountConfirmButton onClick={confirmDeleteAddress} variant="contained">
              {' '}
              {t('account:confirmationYes')}
            </AccountConfirmButton>
          </Stack>
        }
      />
    </>
  );
}
